<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'MyToken'
};
</script>

<style lang="less" scoped></style>
